export const formatValue = (value: number, isValid = true): string => {
  const formattedValue = value / 100;

  if (Number.isNaN(formattedValue) || !isValid) {
    return '-';
  }

  return `£${(value / 100).toFixed(2)}`;
};
